
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.63 13.498a1.423 1.423 0 011.585-1.238l4.475.55c.78.095 1.335.805 1.239 1.585l-.098.8-7.409-.012.207-1.685z","fill":"#08C1AB"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.52 9.003a1.423 1.423 0 00-1.624 1.193l-.528 3.476a1.423 1.423 0 001.407 1.637h4.867l.237-1.534a2.491 2.491 0 012.364-2.108l.028-.188a1.423 1.423 0 00-1.19-1.616l-5.56-.86z","fill":"#9FFCEA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.004 16.312a3.201 3.201 0 00-3.202 3.201v7.415a3.202 3.202 0 003.202 3.201h14.94a3.202 3.202 0 003.202-3.201v-2.593h-2.697a1.114 1.114 0 110-2.229h2.697v-2.593a3.201 3.201 0 00-3.202-3.201h-14.94z","fill":"#0AA89D"}})])
          )
        }
      }
    